/* eslint-disable */
import PropTypes from 'prop-types';
import ServicesContextPropTypes from '../../Contexts/Services/Services.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const EditProfileDialogPropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * Dialog fullscreen
   */
  fullScreen: PropTypes.bool.isRequired,

  /**
   * Whether or not the presence indicator should be hidden
   */
  hidePresence: PropTypes.bool,

  /**
   * The services to be used by the given entry
   */
  services: ServicesContextPropTypes.services.isRequired,

  /**
   * Dialog visible
   */
  visible: PropTypes.bool,
};

export default EditProfileDialogPropTypes;
